import { render, staticRenderFns } from "./PotentialHouse.vue?vue&type=template&id=49a4872f&scoped=true&"
import script from "./PotentialHouse.vue?vue&type=script&lang=js&"
export * from "./PotentialHouse.vue?vue&type=script&lang=js&"
import style0 from "./PotentialHouse.vue?vue&type=style&index=0&id=49a4872f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a4872f",
  null
  
)

export default component.exports